import _get from 'lodash/get';
import React, { Dispatch, useCallback, useContext, useEffect, useRef, useState } from 'react';
import { gql } from '@apollo/client';
import { Mutation } from '../types';
import { useDataRequest } from './useDataRequest';

export const SCHEMA_QUERY = gql`
	query GetSchemaQuery {
		__schema {
			mutationType {
				fields {
					name
					type {
						kind
						ofType {
							kind
							name
						}
						fields {
							name
							type {
								kind
								name
								fields {
									name
									args {
										name
										type {
											kind
											name
											inputFields {
												name
												type {
													kind
													name
													ofType {
														kind
														name
													}
												}
											}
										}
									}
								}
							}
						}
					}
				}
			}
		}
	}
`;

export function useSchema() {
	const [mutations, setMutations] = useState<Mutation[]>();
	const { useQuery } = useDataRequest();
	const res = useQuery(SCHEMA_QUERY);

	useEffect(() => {
		const _groups = _get(res, 'data.__schema.mutationType.fields', []) as any[];
		const mutations = _groups.reduce<Mutation[]>((acc1, _group) => {
			_get(_group, 'type.fields').forEach((mutation: any) => {
				const _fields = _get(
					_get(mutation, 'type.fields').find((f: any) => f.name === 'salva'),
					'args[0].type.inputFields',
					[]
				);
				const fields = _fields.map((field: any) => {
					let type = field.type.ofType ? field.type.ofType.name.toLowerCase() : undefined;
					if (field.type.name) type = field.type.name.toLowerCase();
					return {
						name: field.name,
						required: field.type.kind === 'NON_NULL',
						type,
					};
				});
				const obj = {
					id: `${_group.name}.${mutation.name}`,
					group: _group.name,
					name: mutation.name,
					fields,
				};
				acc1.push(obj);
			});
			return acc1;
		}, []);
		setMutations(mutations);
	}, [res]);

	return {
		mutations,
	};
}
